import { IndexPath, Select, SelectItem } from "@ui-kitten/components";
import { SubscriptionDetails } from "features/types";
import React, { useEffect, useState } from "react";
import { View } from "react-native";

interface PlanPackageSelectorProps {
  uniqSubscriptions: SubscriptionDetails[];
  onSelect: (sub: SubscriptionDetails) => void;
  selectedSubscription: SubscriptionDetails | null;
}
const PlanPackageSelector: React.FC<PlanPackageSelectorProps> = ({
  uniqSubscriptions,
  onSelect,
  selectedSubscription,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(new IndexPath(0));

  useEffect(() => {
    if (!selectedSubscription) return;
    const index = uniqSubscriptions.findIndex(
      (sub) => sub.planPackage.id === selectedSubscription.planPackage.id
    );
    if (index >= 0) {
      setSelectedIndex(new IndexPath(index));
    }
  }, [selectedSubscription]);

  return (
    <View>
      <Select
        label="Available Plan Packages"
        value={uniqSubscriptions[selectedIndex.row].planPackage.displayName}
        selectedIndex={selectedIndex}
        onSelect={(index) => {
          setSelectedIndex(index as IndexPath);
          onSelect(uniqSubscriptions[(index as IndexPath).row]);
        }}
      >
        {uniqSubscriptions.map((subscription) => (
          <SelectItem
            key={subscription.id}
            title={subscription.planPackage.displayName}
          ></SelectItem>
        ))}
      </Select>
    </View>
  );
};

export default PlanPackageSelector;
